import { render, staticRenderFns } from "./Input-Message.vue?vue&type=template&id=28453b47&lang=pug"
import script from "./Input-Message.vue?vue&type=script&lang=ts"
export * from "./Input-Message.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports